import { render, staticRenderFns } from "./TaskBrocastList.vue?vue&type=template&id=d050c418&scoped=true&"
import script from "./TaskBrocastList.vue?vue&type=script&lang=js&"
export * from "./TaskBrocastList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d050c418",
  null
  
)

export default component.exports